import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  getAccountInfo,
  selectAccountInfo,
} from "../../../state/ducks/member/index";

class AccountInfo extends Component {
  componentDidMount() {
    this.props.getAccountInfo();
  }

  render() {
    const { account } = this.props;
    return (
      <>
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
            {/* KUTU 1 */}
            <div className="row no-gutters t-kutu t-yesilCizgi">
              <div
                className="col bosluk backtop"
                style={{
                  backgroundImage:
                    'url("/assets/img/backgrounds/back_top_yesil.jpg")'
                }}
              >
                {/* içerikler */}
                {/* Başlık */}
                <div className="row no-gutters pb-4">
                  <div clss="col-auto">
                    <i className="t-icon-user1 icon" />
                  </div>
                  <div className="col d-flex flex-column justify-content-center">
                    <div className="baslik">Profilim</div>
                    <span className="altBaslik">Üyelik Bilgilerim</span>
                  </div>
                </div>
                {/* Ad Soyad */}
                <div className="row no-gutters pt-4">
                  <div className="col-12 satirOzellikleri">
                    <span className="maviBaslik">Adı Soyadı</span>
                    <span>{account?.adi + " " + account?.soyAdi}</span>
                  </div>
                  <div className="col-12 t-hr">
                    <hr />
                  </div>
                </div>
                {/* Doğum Yeri */}
                <div className="row no-gutters pt-4">
                  <div className="col-12 satirOzellikleri">
                    <span className="maviBaslik">Doğum Yeri</span>
                    <span>{account?.dogumYeri}</span>
                  </div>
                  <div className="col-12 t-hr">
                    <hr />
                  </div>
                </div>
                {/* TC */}
                <div className="row no-gutters">
                  <div className="col-12 satirOzellikleri">
                    <span className="maviBaslik">TC Kimlik No</span>
                    <span>{account?.vatandaslikNo}</span>
                  </div>
                  <div className="col-12 t-hr">
                    <hr />
                  </div>
                </div>
                {/* mail */}
                <div className="row no-gutters">
                  <div className="col-12 col-lg satirOzellikleri">
                    <span className="maviBaslik">Mail adresi</span>
                    <span>{account?.eposta}</span>
                  </div>
                  <div className="col-12 col-lg-auto">

                    <Link to="/Home/ControlContactInfo/Eposta" className="t-icButonMavi">
                      Değiştir
                      <i className="t-icon-arrow-right2" />
                    </Link>
                  </div>
                  <div className="col-12 t-hr">
                    <hr />
                  </div>
                </div>
                {/* GSM */}
                <div className="row no-gutters">
                  <div className="col-12 col-lg satirOzellikleri">
                    <span className="maviBaslik">Cep Telefonu</span>
                    <span>{account?.cepTelefonu}</span>
                  </div>
                  <div className="col-12 col-lg-auto">

                    <Link to="/Home/ControlContactInfo/Gsm" className="t-icButonMavi">
                      Değiştir
                      <i className="t-icon-arrow-right2" />
                    </Link>
                  </div>
                  <div className="col-12 t-hr">
                    <hr />
                  </div>
                </div>
                {/* Adres */}
                <div className="row no-gutters">
                  <div className="col-12 satirOzellikleri">
                    <span className="maviBaslik">Adresi</span>
                    <span>
                    {account?.adres}
                    </span>
                  </div>
                </div>
                {/* içerikler BİTTİ */}
              </div>
              <div className="col-auto renk" />
            </div>
            {/* KUTU 1 BİTTİ */}
          </div>
        </div>
        {/* Duyurlar Baslık*/}
        {/* duyrular Bitti*/}
        <div className="row" style={{ height: 30 }} />
      </>

    );
  }
}

const mapStateToProps = (state) => {
  return {
    account: selectAccountInfo(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  getAccountInfo: () => dispatch(getAccountInfo()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountInfo);
